import { produce } from "immer";
import * as modalActions from "store/actions/modalActions";

const initialState = {
  isDeleteModalOpen: false,
  selectedIds: []
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case modalActions.OPEN_DELETE_DIALOG: {
      const { selectedIds } = action.payload;

      draft.isDeleteModalOpen = true;
      draft.selectedIds = selectedIds;
      break;
    }

    case modalActions.CLOSE_DELETE_DIALOG: {
      draft.isDeleteModalOpen = false;
      draft.selectedIds = [];
      break;
    }

    default:
      return draft;
  }
}, initialState);

export default reducer;
